import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AppDataService, ProductService, MerchantService } from 'app/services';
import { MerchantVerificationCheckEnum, ProductStatusEnum } from 'app/models';
import { MerchantStoreOnboardingComponent, MerchantProductsComponent } from 'app/merchant';
import { cl } from '@fullcalendar/core/internal-common';

@Component({
    selector: 'merchant-approved-reject-product',
    templateUrl: './merchant-approved-reject-product.component.html',
    styleUrls: ['./merchant-approved-reject-product.component.scss',
        '../../../../../styles/sidebar.scss',
        '../../../../../styles/style-layout.scss'],
    providers: [MessageService]
})
export class MerchantApprovedRejectProductComponent implements OnInit {
    public productId: number = 0;
    @Input()
    set _productId(value: number) {
        this.productId = value;
        if (this.productId > 0) {
            this.getProduct();
        }
    }

    public merchantId: number = 0;
    @Input()
    set _merchantId(value: number) {
        this.merchantId = value;
        if (this.merchantId > 0) {
            this.getMerchantVerificationCheckLists();
        }
    }

    public showMerchantApprovedRejectProductSideBar: boolean = false;
    @Input()
    set _showMerchantApprovedRejectProductSideBar(value: boolean) {
        this.showMerchantApprovedRejectProductSideBar = value;
    }

    @Input() public merchantStoreOnboardingComponent!: MerchantStoreOnboardingComponent;
    @Input() public merchantProductsComponent!: MerchantProductsComponent;

    @Output() changedShowMerchantApprovedRejectProductSideBarEmit = new EventEmitter<boolean>();
    changedShowMerchantApprovedRejectProductSideBar(increased: any) {
        this.changedShowMerchantApprovedRejectProductSideBarEmit.emit(increased);
    }

    constructor(private messageService: MessageService,
        public appData: AppDataService, private productService: ProductService,
        private merchantService: MerchantService) { }

    public loading: boolean = false;

    public showMerchantRejectProductModal: boolean = false;

    public product: any = {};

    public productStatusEnum = ProductStatusEnum;

    ngOnInit(): void { }

    public getProduct() {
        this.loading = true;

        const dto = {
            ProductId: this.productId
        };

        this.productService.getProductForEdit(dto, this.messageService).then(data => {
            if (!data) {
                this.loading = false;
                return;
            }

            if (!data.Success) {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }
            console.log(data);
            this.product = data;
            this.loading = false;
        });
    }

    public questions: { name: string; question: string; checkId: MerchantVerificationCheckEnum; isChecked: boolean }[] = [
        {
            name: 'Blurry Image', question: '',
            checkId: MerchantVerificationCheckEnum.BlurryImage, isChecked: false
        },
        {
            name: 'Is name match to the label of the product?', question: '',
            checkId: MerchantVerificationCheckEnum.IsNameMatchToTheLabelOfTheProduct, isChecked: false
        },
        {
            name: 'Lorem ipsum dolor', question: '',
            checkId: MerchantVerificationCheckEnum.LoremIpsumDolor, isChecked: false
        }
    ];
    getMerchantVerificationCheckLists() {
        const dto = {
            MerchantId: this.merchantId,
            ProductId: this.productId
        };

        this.loading = true;

        this.merchantService.getMerchantVerificationCheckLists(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                const questions = this.questions;

                data.Items.forEach((item: any) => {
                    const findItem = questions.find((obj) => {
                        const result = obj.checkId === item.CheckId;
                        return result;
                    });

                    if (findItem !== undefined) {
                        const index = questions.indexOf(findItem);
                        questions[index].isChecked = item.IsChecked;
                    }
                });
                this.checkVerificationForContinue();
                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }
    checkVerificationForContinue() {
        let countIsChecked = 0;

        this.questions.forEach(q => {
            if (q.isChecked) {
                countIsChecked += 1;
            } else {
                countIsChecked -= (countIsChecked > 0) ? 1 : 0;
            }
        });
    }
    addOrUpdateMerchantVerificationCheckList(question: any) {
        const dto = {
            MerchantId: this.merchantId,
            ProductId: this.productId,
            CheckId: question.checkId,
            IsChecked: question.isChecked
        };

        this.merchantService.addOrUpdateMerchantVerificationCheckList(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    question.isChecked = false;
                    this.checkVerificationForContinue();
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Data has been updated' });
                this.checkVerificationForContinue();
            })
            .catch(err => {
                question.isChecked = false;
                this.checkVerificationForContinue();
                throw err;
            });
    }
    public approvedOrReject(productStatus: ProductStatusEnum) {
        const dto = {
            ProductId: this.productId,
            RejectReason: this.product.RejectReason,
            ProductStatusId: productStatus
        };

        this.productService.approvedOrRejectProductStatus(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Data has been updated' });
                this.changedShowMerchantApprovedRejectProductSideBar(false);
            });

    }

    public openMerchantRejectProductModal() {
        this.showMerchantRejectProductModal = !this.showMerchantRejectProductModal;
    }
    changedShowMerchantRejectProductModalEmit(value: any) {
        if (value.isSaveBtn) {
            this.product.RejectReason = this.product.RejectReason + '. ' + value.rejectValue;
            this.approvedOrReject(ProductStatusEnum.Rejected);
        }
        this.showMerchantRejectProductModal = value.displayModal;
    }

    cancel() {
        this.changedShowMerchantApprovedRejectProductSideBar(!this.showMerchantApprovedRejectProductSideBar);
    }
}
